export const formatDate = (isoString) => {
  if (isoString == null) return "";
  else {
    const date = new Date(isoString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }
};
export const convertToSlug = (str) => {
  if (str !== "undefined") {
    str = str?.toLowerCase();
    str = str?.normalize("NFD")?.replace(/[\u0300-\u036f]/g, "");
    str = str?.replace(/[đĐ]/g, "d");
    str = str?.replace(/([^0-9a-z-\s])/g, "");
    str = str?.replace(/ /gi, "-");
    str = str?.replace(/-----/gi, "-");
    str = str?.replace(/----/gi, "-");
    str = str?.replace(/---/gi, "-");
    str = str?.replace(/--/gi, "-");
    str = "@" + str + "@";
    str = str?.replace(/@-|-@|@/gi, "");
  }
  return str;
};

export const formatCurrencyVND = (amount) => {
  return new Intl.NumberFormat("vi-VN", {
    style: "currency",
    currency: "VND",
  }).format(Number(amount));
};

export const getAbbreviation = (name) => {
  return name
    .split(/\s+/) // Tách các từ dựa trên khoảng trắng
    .filter((word) => word.length > 0) // Loại bỏ các từ rỗng (nếu có)
    .slice(0, 3) // Giới hạn tối đa 3 từ đầu tiên
    .map((word) => word[0].toUpperCase()) // Lấy chữ cái đầu tiên và viết hoa
    .join(""); // Ghép lại thành chuỗi
};

export const formatDateReverse = (isoString) => {
  if (!isoString) return "";
  const utcDate = new Date(
    Date.UTC(isoString.getFullYear(), isoString.getMonth(), isoString.getDate())
  );
  return utcDate.toISOString().split("T")[0];
};

export const capitalize = (text) => {
  if (!text) return "";
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
};

export const capitalizeWords = (text) => {
  return text
    .split(" ")
    .map((word) => capitalize(word))
    .join(" ");
};
